import type { GetPermissionsParams, GetPermissionsResponse } from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const permissionsApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getPermissions: build.query<GetPermissionsResponse, GetPermissionsParams>({
      query: () => '/permissions',
    }),
  }),
});

export const { useGetPermissionsQuery } = permissionsApis;
